// Modules
import React from "react";

// Styles
import "./MvModal.sass"

// Components
import MvIcon from "Generic/MvIcon";

type Props = {
    openModal: boolean;
    toggleModal: () => void;
    id?: string
    scrollY?: boolean;
    iconColor?: string;
}

class MvModal extends React.Component<Props> {


    render(){
      if (!this.props.openModal) {
          return false;
        }

        return (
            <React.Fragment>
                <section
                  className={`${!this.props.openModal ? "main-overlay hide" : "main-overlay"} ${this.props.scrollY ? "scroll-y" : ""}`}
                  id={this.props.id ? this.props.id : ""}
                >
                    <div className="content">
                        <div className="modal-top">
                               {this.props.children}
                               <button
                                 className="times-button"
                                 onClick={this.props.toggleModal}
                               >
                                 <MvIcon
                                   color="#777"
                                   style={{
                                     height: "20px",
                                     width: "20px"
                                   }}
                                   icon="times"
                                 />
                               </button>
                        </div>
                    </div>
                </section>
                <div
                  className={!this.props.openModal ? "black-overlay hide" : "black-overlay"}
                  onClick={this.props.toggleModal}
                >
                </div>
            </React.Fragment>
        )
    }
}

export default MvModal
